import { Button } from 'app/components/design-system-components'
import { muvalReferralURL } from 'app/Integrations/components/Muval/config'
import { useGTMTracking } from 'app/utils/hooks/useGTMTracking'

interface MuvalPreApprovedButtonProps {
  trackingClassName: string | undefined
}

function MuvalPreApprovedButton({
  trackingClassName = '',
}: MuvalPreApprovedButtonProps) {
  const MUVAL_URL = muvalReferralURL()
  const {
    trackingProps: { className: trackClassName, onClick },
  } = useGTMTracking(trackingClassName, MUVAL_URL)

  return (
    <Button
      p={4}
      sizeVariant="large"
      width="100%"
      className={trackClassName}
      onClick={onClick}
    >
      Get quotes
    </Button>
  )
}

export default MuvalPreApprovedButton
